<template>
    <div>
        <div v-for="card in creditCards" :key="card.id" class="credit-card">
            <div class="payment-radios" @click="setSelectedCard(card)">
                <input class="with-gap" v-model="selectedCard" :value="card.id" :id="card.id" type="radio" />
                <label class="credit-card-label" :for="card.id">
                    <p class="credit-card-name">
                        {{ card.paymentCompany.name }} - <span>****{{ card.cardNumberLastFour }}</span>
                    </p>
                    <p>Titular: {{ card.holderName }}</p>
                </label>
            </div>
            <span @click="deleteSelectedCard(card.id)" title="Remover Cartão" class="material-icons card-remove-btn">
                delete
            </span>
        </div>
        <div class="credit-card-more" @click="sendFormCard">
            <span v-if="addNewCard" class="credit-card-more-new">
                <span class="material-icons"> add_card </span> Adicionar novo cartão</span
            >
            <span v-if="!addNewCard" class="credit-card-more-close">
                <span class="material-icons"> close </span> Cancelar
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CardList',
    data: () => ({
        selectedCard: ''
    }),
    props: {
        creditCards: {
            type: Array
        },
        addNewCard: {
            type: Boolean,
            default: true
        },
        changeSelectedCard: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        async sendFormCard() {
            this.$emit('showForm');
        },
        setSelectedCard(card) {
            this.selectedCard = card.id;
            this.$emit('setSelectedCard', card.id);
        },
        deleteSelectedCard(id) {
            this.$emit('deleteSelectedCard', id);
        }
    },
    watch: {
        changeSelectedCard: {
            deep: true,
            handler() {
                this.selectedCard = '';
            }
        }
    }
};
</script>
<style scoped>
.credit-card {
    padding: 20px;
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.credit-card-label {
    display: flex !important;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
}
.credit-card-name {
    font-weight: 600;
    color: #707070;
}
.credit-card-more {
    margin-bottom: 12px;
}
.credit-card-more .credit-card-more-new,
.credit-card-more .credit-card-more-close {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    color: #707070;
    width: 100%;
    gap: 12px;
    padding: 12px;
}
.credit-card-more:hover {
    background-color: #f9f9f9;
    cursor: pointer;
}
.credit-card-more .material-icons {
    font-size: 18px;
}
.credit-card-more .credit-card-more-close {
    color: red;
}
.card-remove-btn {
    color: red;
}
.card-remove-btn:hover {
    cursor: pointer;
}
@media screen and (max-width: 1366px) {
    .credit-card {
        align-items: flex-start;
        gap: 12px;
    }
    .credit-card-label {
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        height: auto !important;
    }
    .credit-card-label p {
        margin: 2px;
        line-height: 1.4rem;
    } 
}
</style>
